import {
  Box,
  Text,
  Link,
  Image,
  withDefaultColorScheme,
} from "@chakra-ui/react";
import Route from "./common/route";
import { useRouter } from "next/router";
import { GetCookie } from "../provider/common";

// ========== 데이터 함수들 ===========

export const description = (data) => {
  let _manufacturer = data.manufacturer;
  let _description = data.description;
  let _pn = data.pn;
  return (
    <Text fontSize="12px" color="gray">
      {_manufacturer === ""
        ? `${_pn}--${_description}`
        : _pn === ""
        ? `${_manufacturer}--${_description}`
        : _description}
    </Text>
  );
};

export const Goto = (pics, data, isLoginCheck, keyword) => {
  const router = useRouter();
  const axios = require("axios").default;
  const CombineBotAsked = async () => {
    // 로그인이 되어있으면 견적바구니로 바로 요청
    if (isLoginCheck === "1") {
      const body = [];

      body.push({
        it_id: data.it_id,
        it_brand: data.manufacturer,
        it_name: data.pn,
        it_maker: data.source,
        qty: pics.stock,
      });

      try {
        const URL = process.env.PANDA_API_URL + "/api/mall/insertQuoteLists";
        const result = await axios.post(URL, body, {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${await GetCookie("token")}`,
          },
        });
        if (result.data.status === 200) {
          if (
            confirm(
              "견적바구니에 저장되었습니다. 견적바구니로 이동하시겠습니까?"
            ) === true
          ) {
            router.push(`/marketplace/cart`);
            return;
          }
        } else {
          alert("견적바구니에 저장이 실패하였습니다.");
        }
      } catch (e) {
        console.log(e);
        alert("견적바구니에 저장이 실패하였습니다.");
      }
    } else {
      const basePath = `/search/lists?keyword=${keyword}`;
      const href = `/auth/login?before=${basePath}`;
      router.push(href);
    }
    // 미 로그인 되어있으면 로그인 화면으로 간다.
  };

  if (pics.source === "partner") {
    return (
      <Link
        text="컴바인 견적문의"
        backgroundColor="orange"
        classProp={"search-list_provider__goto-ask flex-center"}
        className="search-list_provider__goto-ask flex-center"
        onClick={() => CombineBotAsked()}
      >
        컴바인 견적문의
      </Link>
    );
  } else if (
    pics.source === "pandaparts" &&
    pics.item_price !== undefined &&
    pics.item_price !== 0
  ) {
    return (
      <Route
        text="구매하러가기"
        classProp={"search-list_provider__goto flex-center"}
        href={`/parts/mallview/${pics.it_id}`}
      />
    );
  } else if (Number(pics.stock) === 0 || Number(pics.price) === 0) {
    return (
      <Link
        text="컴바인 견적문의"
        backgroundColor="orange"
        classProp={"search-list_provider__goto-ask flex-center"}
        onClick={() => CombineBotAsked()}
        className="search-list_provider__goto-ask flex-center"
      >
        컴바인 견적문의
      </Link>
    );
  } else if (pics.source === "pandaparts") {
    return (
      <Route
        text="구매하러가기"
        classProp={"search-list_provider__goto flex-center"}
        href={`/parts/view/ON${pics.stock_no}`}
      />
    );
    // 디지키가 아니면서 아날로그 디바이스이면 컴바인봇 견적 문의하기
  } else if (
    pics.source !== "digikey" &&
    data.manufacturer.toLowerCase().includes("analog device")
  ) {
    return (
      <Link
        text="컴바인 견적문의"
        backgroundColor="orange"
        classProp={"search-list_provider__goto-ask flex-center"}
        onClick={() => CombineBotAsked()}
        className="search-list_provider__goto-ask flex-center"
      >
        컴바인 견적문의
      </Link>
    );
  } else {
    return (
      <Route
        text="구매하러가기"
        classProp={"search-list_provider__goto flex-center"}
        href={`/parts/view/PD${pics.stock_no}`}
      />
    );
  }
};
export const period = (data) => {
  if (data.recent_period + data.add_days !== 0) {
    return (
      <>
        <Text>
          {data.recent_period}~{data.recent_period + data.add_days}일
        </Text>
        <Text className="search-list_export">국내출고 예정</Text>
      </>
    );
  } else {
    return (
      <Text textAlign="center" width="50px">
        미정
      </Text>
    );
  }
};

export const logo = (data) => {
  let logo_url = "";
  let width = "";
  switch (data.source) {
    case "mouser":
      logo_url = "/images/brand/mouser.png";
      break;
    case "digikey":
      logo_url = "/images/brand/dk_real_logo.png";
      break;
    case "arrow":
      logo_url = "/images/brand/arrow.png";
      break;
    case "verical":
      logo_url = "/images/brand/veri.png";
      break;
    case "onechip":
      logo_url = "/images/brand/one.png";
      break;
    case "dfrobot":
      logo_url = "/images/brand/df.png";
      break;
    case "seeed":
      logo_url = "/images/brand/see.png";
      break;
    case "pandaparts":
      logo_url = "/images/brand/logo_pandaparts.png";
      break;
    case "future":
      logo_url = "/images/brand/alliance.png";
      break;
    case "corestaff":
      logo_url = "/images/brand/alliance.png";
      break;
    case "pei":
      logo_url = "/images/brand/alliance.png";
      break;
    case "partner":
      logo_url = "/images/brand/logo_partner.png";
      break;
    default:
      logo_url = "/images/no_img.png";
      break;
  }
  return (
    <>
      {data.source === "partner" || data.source === "pandaparts" ? (
        <Image width="95%" src={logo_url} />
      ) : data.source === "digikey" ? (
        <Image width="70px" src={logo_url} />
      ) : (
        <Image width="50px" src={logo_url} />
      )}
    </>
  );
};
